import P from '../../pages';
import { generateProfileElementObject } from '../../utilities';;
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { defaultMessages } from '../../../../libs/i18n/default';
import ReactOnRails from 'react-on-rails';
import FormHeader from './FormHeader';
import Redirector from './Redirector';
import Upload from 'react-icons/lib/fa/upload';
import Button from 'react-bootstrap/lib/Button';
import Modal from 'react-bootstrap/lib/Modal';
import { Redirect } from 'react-router-dom';
import CheckboxOrRadioGroup from './CheckboxOrRadioGroup';
import SelectGroup from './SelectGroup';
import ButtonGroup from './ButtonGroup';
import ResidentForm from './ResidentForm';
import ReactMarkdown from 'react-markdown';
import Home from 'react-icons/lib/md/home';
import Edit from 'react-icons/lib/md/edit';
import ResidentPhotoUpload from './ResidentPhotoUpload';
import ResidentCertificateUpload from './ResidentCertificateUpload';
import ResidentPoliceVettingUpload from './ResidentPoliceVettingUpload'
import { get, capitalize } from 'lodash';

class Residents extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      page: this.props.page
    }
    this.handleEditResident = this.handleEditResident.bind(this);
    this.submit = this.submit.bind(this);
    this.back = this.back.bind(this);
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.handleNewResident = this.handleNewResident.bind(this);
    this.residentGender = this.residentGender.bind(this);
  }

  getInitialState() {
    return {
      showModal: false,
      editing: false
    };
  }

  handleNewResident() {
    const initialState = {
      showModal: true,
      editing: true,
      activeResident: {
        given_names: '',
        middle_names: '',
        family_name: '',
        middle_names_na: false,
        email: '',
        at_home: true,
        international_student: false,
        gender: '',
        dob: '',
        household_position: '',
        occupation: '',
        employer: '',
        phone_mobile: '',
        ssn: '',
        education: ''
      }
    }

    if (this.props.territory.covid_vaccination_fields) {
      initialState.vaccination_state = ''
      initialState.dose_on_on = ''
      initialState.dose_two_on = ''
    }

    this.setState(initialState);
  }

  handleEditResident(e, payload) {
    console.log("CLICKED EDIT", payload);
    e.preventDefault();
    this.setState({
      showModal: true,
      editing: true,
      activeResident: payload
    });
  }

  componentWillMount() {
    this.props.onFetchResidentsIfNeeded();
  }

  back(e) {
    this.props.onGoBack();
  }

  submit(e) {
    this.props.onResidentsSubmit();
  }

  close() {
    this.setState({ showModal: false });
    this.props.onFetchResidentsIfNeeded();
  }

  open() {
    this.setState({ showModal: true });
  }

  residentGender(resident) {
    const { formatMessage } = this.props.intl;
    switch (resident.gender) {
      case 'Male':
        return formatMessage(defaultMessages.clientCommonMale);
      case 'Female':
        return formatMessage(defaultMessages.clientCommonFemale);
      case 'Other':
        return formatMessage(defaultMessages.clientCommonOtherGender);
      default:
        return ''
    }
  }

  godaddyIcon() {
    if (this.props.content.territory_code == "usa") {
      return (
        <img src="/images/host-sign-up/secure.png" className='pull-right' style={{ margin: '25px 0' }} />
      )
    } else {
      return (null)
    }
  }

  render() {
    const thisPage = P.RESIDENTS_PAGE;
    const { formatMessage } = this.props.intl;
    const content = this.props.content;
    const page = this.props.page;
    const { items: residents, isFetching, lastUpdated } = this.props.residents;
    const { editing, activeResident, formAction } = this.state;
    const DefaultSsn = this.state.ssn;
    const requireGender = this.props.territory.require_gender_for_all_residents;

    const checkGender = () => {
      let valid = true

      if (requireGender) {
        residents.forEach((resident) => {
          valid = valid && !!resident.gender
        })
      }

      return valid
    }

    return (
      <div id={page} className='profile'>
        <Redirector this_page={thisPage} page={page} />
        <form>
          <FormHeader title={content.pages.residents.title} icon={<Home />} />
          <div dangerouslySetInnerHTML={{ __html: content.pages.residents.body}} />
          <Button
            onClick={this.handleNewResident}
            id='add-btn'>
            {formatMessage(defaultMessages.clientHostPagesResidentsActionsCreate)}
          </Button>
          {this.godaddyIcon()}
          <table className="table table-striped">
            <thead>
              <tr>
                <th>{formatMessage(defaultMessages.clientHostPagesResidentsLabelsName)}</th>
                <th>{formatMessage(defaultMessages.clientHostPagesResidentsLabelsAge)}</th>
                <th>{formatMessage(defaultMessages.clientHostPagesResidentsLabelsGender)}</th>
                <th>Photo</th>
                <th>Edit</th>
              </tr>
            </thead>
            <tbody>
              {residents.map((resident, i) => {
                return (
                  <tr key={i}>
                    <td>
                      {resident.name}
                      <div className='flex-gap'>
                        {resident.vaccination.certificate_name !== '' && resident.vaccination.uploaded_certificate === false && (
                          <ResidentCertificateUpload
                            resident={resident}
                            intl={this.props.intl}
                            user={this.props.user}
                            uploader={this.props.uploader}
                            territory={this.props.territory}
                            onCertificateFormSubmit={this.props.onCertificateFormSubmit}
                            content={this.props.content}
                          />
                        )}
                        {this.props.territory.code === 'NZ' && !resident.uploaded_police_vetting && resident.police_vetting_required && (
                          <ResidentPoliceVettingUpload
                            resident={resident}
                            user={this.props.user}
                            uploader={this.props.uploader}
                            onPoliceVettingFormSubmit={this.props.onPoliceVettingFormSubmit}
                          />
                        )}
                      </div>
                    </td>
                    <td>{resident.age}</td>
                    <td>{this.residentGender(resident)}</td>
                    <td>
                      <ResidentPhotoUpload
                        intl={this.props.intl}
                        photo={resident.photos[0]}
                        resident={resident}
                        onPhotoFormSubmit={this.props.onPhotoFormSubmit}
                        didInvalidate={this.props.residents.didInvalidate}
                        onPhotoDestroySubmit={this.props.onPhotoDestroySubmit}
                        user={this.props.user}
                        uploader={this.props.uploader}
                        alertContent={content.pages.residents.photo_info}
                        disablePhotoTitle={this.props.territory.disable_host_photos_title_field} />
                    </td>
                    <td><a href="javascript:void(0)" id={`edit-resident-${i}`} onClick={(e) => this.handleEditResident(e, resident)}><Edit /></a></td>
                  </tr>
                )
              })}
            </tbody>
          </table>

          {isFetching && residents.length === 0 && <h2>{formatMessage(defaultMessages.clientHostPagesResidentsLabelsLoadingResidents)}</h2>}
          {!isFetching && residents.length === 0 && <h2>{formatMessage(defaultMessages.clientHostPagesResidentsLabelsNoResidents)}</h2>}

          <ButtonGroup
            backFunc={this.back}
            submitFunc={this.submit}
            disableSubmit={!checkGender()}
            page={thisPage}
            user={this.props.user}
            intl={this.props.intl} />

        </form>

        <Modal show={this.state.showModal} onHide={this.close}>
          <Modal.Header closeButton>
            <Modal.Title>{activeResident && activeResident.id ?
              formatMessage(defaultMessages.clientHostPagesResidentsActionsUpdate) :
              formatMessage(defaultMessages.clientHostPagesResidentsActionsCreate)

            }</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ResidentForm
              intl={this.props.intl}
              content={this.props.content}
              resident={activeResident}
              onResidentFormSubmit={this.props.onResidentFormSubmit}
              requiredFields={this.props.requiredFields}
              onClose={this.close}
              residentVaccinationOptions={this.props.residentVaccinationOptions}
              territory={this.props.territory}
              vaccinationMandatory={this.props.vaccinationMandatory}
              householdVaccination={this.props.householdVaccination}
            />
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

Residents.propTypes = {
  onResidentsRefresh: PropTypes.func,
  onResidentsSubmit: PropTypes.func,
  onSkipSubmit: PropTypes.func,
  onGoBack: PropTypes.func,
  page: PropTypes.string,
  intl: PropTypes.object,
  content: PropTypes.object,
  residents: PropTypes.object
};

export default injectIntl(Residents);
